module.exports = __webpack_public_path__ + "img/appStore.a87abf39.svg";